import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const ServiceAreaSettings = ({ settings, setSettings, updateSettings }) => {
  const [newZipCode, setNewZipCode] = useState('');

  const addZipCode = () => {
    if (newZipCode && newZipCode.length === 5 && /^\d+$/.test(newZipCode)) {
      const currentZips = settings.service_area_zip_codes || [];
      if (!currentZips.includes(newZipCode)) {
        setSettings({
          ...settings,
          service_area_zip_codes: [...currentZips, newZipCode]
        });
        setNewZipCode('');
      } else {
        alert('This zip code is already in your service area');
      }
    } else {
      alert('Please enter a valid 5-digit zip code');
    }
  };

  const removeZipCode = (zipToRemove) => {
    const currentZips = settings.service_area_zip_codes || [];
    setSettings({
      ...settings,
      service_area_zip_codes: currentZips.filter(zip => zip !== zipToRemove)
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle style={{ fontSize: '1.25rem' }}>🚗 Service Area Zip Codes</CardTitle>
      </CardHeader>
      <CardContent>
        <div style={{ marginBottom: '1rem' }}>
          <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '1rem' }}>
            Only customers in these zip codes can book pickups. This prevents out-of-area bookings.
          </p>
          
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
            <input
              type="text"
              value={newZipCode}
              onChange={(e) => setNewZipCode(e.target.value)}
              placeholder="Enter zip code (e.g., 85254)"
              maxLength="5"
              style={{
                flex: 1,
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.875rem'
              }}
            />
            <Button
              onClick={addZipCode}
              style={{
                backgroundColor: '#10b981',
                color: 'white',
                padding: '0.75rem 1.5rem'
              }}
            >
              Add Zip
            </Button>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {(settings.service_area_zip_codes || []).map(zip => (
              <div
                key={zip}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.5rem 1rem',
                  backgroundColor: '#f0fdf4',
                  border: '1px solid #10b981',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                  fontWeight: '600'
                }}
              >
                <span>{zip}</span>
                <button
                  onClick={() => removeZipCode(zip)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#ef4444',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    padding: '0',
                    lineHeight: 1
                  }}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>

        <Button
          onClick={() => updateSettings(settings)}
          style={{
            backgroundColor: '#10b981',
            color: 'white',
            padding: '0.75rem 1.5rem',
            marginTop: '1rem'
          }}
        >
          Save Service Area
        </Button>
      </CardContent>
    </Card>
  );
};

export default ServiceAreaSettings;
